import { BUSCAR_ULTIMOS_HISTORICOS_TRECHO, LIMPAR_ULTIMOS_HISTORICOS_TRECHO } from '../../actions/types'

const initialState = undefined

export default function reducerUltimosHistoricosTrecho (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_ULTIMOS_HISTORICOS_TRECHO: {
      const historicos = action.payload.data;
      if (historicos) {
        return  historicos;
      }
      return []
    }

    case LIMPAR_ULTIMOS_HISTORICOS_TRECHO:
        return [];
    
    default: {
      return state
    }
  }
}
